import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import './Investigation.scss'
import { InfoBox } from 'components/message-boxes/information-box/InformationBox'

interface IThankYouProps {
	className?: string
}

const Investigation = ({ className }: IThankYouProps) => {
	const { t } = useTranslation()

	return (
		<div
			className={`investigation ${className !== undefined ? className : ''}`}>
			<InfoBox
				infoType='info'
				message={
					<div className="info-message">
						<Trans t={t} i18nKey="InvestigationDescription"></Trans>
					</div>
				}
			/>
		</div>
	)
}

export default Investigation
